import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {Alert} from 'reactstrap';

@inject("store")
@observer
class MensagemErro extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                { this.props.children &&
                    <Alert color="danger">
                        {this.props.children}
                    </Alert>
                }
            </div>
        );
    }
}

export {MensagemErro}
